import Reveal from "@/components/base/Reveal";
import { stagePairs } from "@/mocks/dailyContest";

export default function Stage() {
  return (
    <section id="stage" className="border-b border-background-300/70 bg-background-100 py-12 md:py-16">
      <div className="container-x">
        <Reveal>
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-primary-600">
              <i className="ri-clapperboard-fill" aria-hidden="true" />
              舞台直拍 · 逐帧对比
            </span>
            <h2 className="mt-3 font-serif text-3xl font-bold leading-tight text-foreground-950 md:text-4xl">
              同一首歌，两种版本的真相
            </h2>
            <p className="mt-4 text-[15px] leading-7 text-foreground-600">
              我们把现场饭拍、官方直拍与录音室版本从收音、运镜、情绪递进到榜单反馈四个维度逐帧对比，
              帮你快速判断哪个版本更适合循环、传播与二创。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 space-y-8">
          {stagePairs.map((pair, i) => (
            <Reveal key={pair.id} delay={i * 60}>
              <article className="grid overflow-hidden rounded-lg border border-background-300/70 bg-background-50 md:grid-cols-2">
                <div className={`relative md:col-span-1 ${i % 2 === 1 ? "md:order-2" : ""}`}>
                  <img
                    src={pair.img}
                    alt={`${pair.theme} ${pair.artist} 舞台直拍对比配图`}
                    title={`每日大赛网 · 直拍对比 · ${pair.artist}`}
                    className="h-64 w-full object-cover object-top md:h-full"
                  />
                  <span className="chip absolute left-3 top-3 bg-primary-600 text-background-50">
                    <i className="ri-focus-3-line mr-1" aria-hidden="true" />
                    {pair.theme}
                  </span>
                </div>
                <div className="flex flex-col p-5 md:p-7">
                  <div className="flex items-baseline justify-between gap-3">
                    <span className="headline-en text-sm font-black text-accent-500">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <h3 className="font-serif text-xl font-bold text-foreground-950 md:text-2xl">{pair.artist}</h3>
                  </div>
                  <p className="mt-3 text-[13px] leading-6 text-foreground-600">{pair.desc}</p>

                  <ul className="mt-5 flex-1 space-y-3">
                    {pair.comparison.map((c) => (
                      <li
                        key={c.kind}
                        className="rounded-md border border-background-300/70 bg-background-100 px-4 py-3"
                      >
                        <div className="flex items-center gap-2">
                          <span className="chip bg-secondary-200 px-2.5 py-0.5 text-secondary-800">{c.kind}</span>
                          <span className="text-xs font-bold text-foreground-800">{c.kind === "榜单反馈" ? "榜单反馈" : c.kind}</span>
                        </div>
                        <p className="mt-2 text-[13px] leading-6 text-foreground-700">{c.point}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-lg border border-primary-200 bg-primary-50 px-6 py-5 sm:flex-row">
            <p className="text-sm text-foreground-700">
              <i className="ri-movie-2-line mr-1 text-primary-600" aria-hidden="true" />
              想要我们对比哪一组舞台？留言告诉我们，下期特别报道优先安排。
            </p>
            <a
              href="#contact"
              className="inline-flex shrink-0 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-[13px] font-bold text-background-50 transition-colors hover:bg-primary-700"
            >
              点我投稿对比
              <i className="ri-send-plane-line" aria-hidden="true" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}